import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import CounterHook from './CounterHook';

export default class Counter extends Component {
  constructor() {
    super();
    this.state = {
      startCounter: false,
    };
  }

  onVisibilityChange = (isVisible) => {
    if (isVisible) {
      this.setState({ startCounter: true });
    }
  };

  render() {
    return (
      <section className='fact-one' id='counter'>
        <div className='container'>
          <div className='block-title text-center'>
            <StaticQuery
              query={graphql`
                {
                  strapiHomePage {
                    counter_heading
                  }
                }
              `}
              render={(data) => (
                <h2 className='block-title__title'>
                  {data.strapiHomePage.counter_heading}
                </h2>
              )}
            />
          </div>
          <div className='row'>
            <CounterHook
              change={this.onVisibilityChange}
              end={this.state.startCounter}
            />
          </div>
        </div>
      </section>
    );
  }
}
